var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((Object.entries(_vm.information)),function(value,index){return (value[1] !== null && value[1] !== '')?_c('div',{key:index,staticClass:"item justify-between lg:flex items-center"},[_c('DetailObjectType',{attrs:{"value":value}})],1):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }